import {postSurveyResponse, SurveyPayload} from "infrastructure/services/surveyResponse.service";
import {retryWithBackoff} from "application/utils/retryWithBackoff";
import {classifySubmitError, isRetriableSubmitError} from "application/utils/submitErrors";
import {removePendingSubmission, savePendingSubmission} from "application/utils/pendingSubmissions";

/*
 * Aqui vamos hacer los cambios para cuendo se defina
 * correctamente como se van a envair todas las respuestas
 * */

export const SurveyResponseService = {
    async enviarGuia(payload: SurveyPayload) {
        try {
            const resultado = await retryWithBackoff(
                () => postSurveyResponse(payload),
                {
                    shouldRetry: isRetriableSubmitError,
                    onRetry: (error, attempt, delayMs) => {
                        const {kind, status} = classifySubmitError(error);
                        if (attempt === 1) {
                            savePendingSubmission(payload);
                        }
                        console.warn(
                            `Envío fallido (${kind}${status ? ` ${status}` : ""}). ` +
                            `Reintento ${attempt} en ${delayMs} ms.`,
                        );
                    },
                },
            );
            removePendingSubmission(payload.token);
            return resultado;
        } catch (error) {
            if (classifySubmitError(error).treatAsCompleted) {
                console.warn("Ya se tenía las respuestas de este token");
                removePendingSubmission(payload.token);
                return null;
            }
            throw error;
        }
    },

};
